// @flow
import { connect } from 'react-redux'
import Card from './Card'
import { getCarousel, getMedia } from '../../../redux/selectors'
import type { Store } from '../../../redux/ducks'
import _ from 'lodash'
import type { CarouselCard } from '../../../redux/ducks/carouselEdit/reducers'
import store from '../../../redux/store'
import getDefaultCrop from '../../getDefaultCrop'
import type { Configs } from '../../types'
import { patch } from '../../../redux/ducks/carouselEdit/reducers'
import type { CardControlVisibility } from './Card'

type OwnProps = {|
  storeId: string,
  configs: Configs,
  cardControlVisibility: CardControlVisibility
|}

function mapStateToProps(state: Store, ownProps: OwnProps) {
  const carousel = getCarousel(state, ownProps.storeId)
  const card = carousel.cards[carousel.currentCardIndex]
  const imageStoreId = card.imageStoreId
  return {
    image: imageStoreId ? getMedia(state, imageStoreId) : null,
    index: carousel.currentCardIndex,
    card
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: OwnProps) {
  const change = (diff: $Shape<CarouselCard>) => {
    const state = store.getState()
    const carousel = getCarousel(state, ownProps.storeId)
    const cards = carousel.cards
    cards[carousel.currentCardIndex] = { ...cards[carousel.currentCardIndex], ...diff }
    dispatch(patch(ownProps.storeId, { cards, errors: [] }))
  }
  return {
    onImageChange: (storeId) => {
      const state = store.getState()
      const image = getMedia(state, storeId)
      const crop = getDefaultCrop(image.width, image.height, 1.0)
      change({ imageStoreId: storeId, crop, imageErrors: [] })
    },
    onUrlChange: (url) => change({ url, urlErrors: [] }),
    onTitleChange: (title) => change({ title, titleErrors: [] }),
    onDescriptionChange: (description) => change({ description, descriptionErrors: [] }),
    onCropChange: (crop) => change({ crop }),
    onVkLinkButtonChange: (vkLinkButton: string) =>
      change({ vkLinkButton, vkLinkButtonErrors: [] }),
    onPriceChange: (price: string) => change({ price, priceErrors: [] }),
    onOldPriceChange: (oldPrice: string) => change({ oldPrice, oldPriceErrors: [] })
  }
}

const CurrentCardContainer = connect<Object, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(Card)

export default CurrentCardContainer
